<template>
  <v-card>
    <v-card-text class="headline secondary--text text-xs-center pb-0">Códigos Promocionais</v-card-text>
    <v-card-text>
      <v-list v-if="codigos.length" dense>
        <v-subheader>Por Combustível</v-subheader>
        <v-list-tile avatar v-for="codigo in codigos" :key="codigo.id">
          <template v-if="combustiveis_grouped">
            <v-list-tile-avatar>
              <svg-filler
                :path="require(`@/assets/combs/${combustiveis_grouped[codigo.combustivel].icone}.svg`)"
                width="35px"
                height="35px"
                :fill="combustiveis_grouped[codigo.combustivel].color"
              />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-text="combustiveis_grouped[codigo.combustivel].nome"
                class="font-weight-bold"
                :style="{ color: combustiveis_grouped[codigo.combustivel].color }"
              ></v-list-tile-title>
              <v-list-tile-sub-title v-text="`${codigo.codigo}`"></v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-action-text
                v-if="codigo.litros_restantes"
                v-text="`Restam ${codigo.litros_restantes} ${combustiveis_grouped[codigo.combustivel].tipo_volume ? combustiveis_grouped[codigo.combustivel].tipo_volume : 'L'}`"
              ></v-list-tile-action-text>
            </v-list-tile-action>
            <v-list-tile-action>
              <v-tooltip bottom>
                <v-btn icon slot="activator" @click="cancelarCodigo(codigo.id)">
                  <v-icon color="red">close</v-icon>
                </v-btn>Cancelar Código
              </v-tooltip>
            </v-list-tile-action>
          </template>
        </v-list-tile>
      </v-list>
      <div
        v-else
        class="text-xs-center title grey--text text--darken-2 font-weight-regular"
      >Sem códigos cadastrados</div>
    </v-card-text>
    <v-card-actions>
      <v-btn flat block color="green" @click="dialogInsercao = true">CADASTRAR CÓDIGOS</v-btn>
    </v-card-actions>
    <v-dialog v-model="dialogInsercao" width="400">
      <v-card>
        <v-card-text class="text-xs-center headline secondary--text">Selecione os Combustíveis</v-card-text>
        <v-container>
          <v-form v-model="valid" ref="form">
            <v-layout row wrap>
              <v-flex
                xs12
                md6
                v-for="combustivel in combustiveis"
                :key="combustivel.id_combustivel"
              >
                <v-layout>
                  <v-flex align-self-center shrink>
                    <v-checkbox
                      :value="combustivel.id_combustivel"
                      v-model="combustiveis_selecionados[`${combustivel.id_combustivel}`]"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex align-self-center class="text-xs-left" grow>
                    <span
                      class="font-weight-bold"
                      :style="{ color: combustivel.color }"
                      v-text="combustivel.nome"
                    ></span>
                  </v-flex>
                  <v-flex align-self-center class="text-xs-right">
                    <svg-filler
                      :path="require(`@/assets/combs/${combustivel.icone}.svg`)"
                      width="35px"
                      height="35px"
                      :fill="combustivel.color"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
        <v-card-actions>
          <v-btn flat block color="green" @click="inserirCodigo()">CONFIRMAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { codigosPromocionaisDao } from '@/api'

export default {
  props: ['convenio'],
  data () {
    return {
      codigos: [],
      dialogInsercao: false,
      combustiveis_selecionados: {},
      valid: false
    }
  },
  watch: {
    convenio (val) {
      if (val) {
        this.carregarCodigos(val)
        if (this.combustiveis) {
          this.$store.dispatch('carregarCombustiveis')
        }
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    posto () {
      return this.$store.getters.posto
    },
    combustiveis () {
      return this.$store.getters.combustiveis
    },
    combustiveis_grouped () {
      if (!this.combustiveis.length) return null
      let group = {}
      this.combustiveis.forEach(combustivel => {
        group[`${combustivel.id_combustivel}`] = combustivel
      })
      return group
    }
  },
  mounted () {
    if (this.convenio) {
      this.carregarCodigos(this.convenio)
      if (this.combustiveis) {
        this.$store.dispatch('carregarCombustiveis')
      }
    }
  },
  methods: {
    cancelarCodigo (codigo) {
      this.$store.dispatch('cancelarCodigo', codigo).then(() => {
        this.carregarCodigos(this.convenio)
      })
    },
    carregarCodigos (convenio) {
      codigosPromocionaisDao
        .porConvenio(this.posto.cnpj, convenio, this.headers)
        .then(response => {
          return response.json()
        })
        .then(json => {
          this.codigos = json
        })
    },
    inserirCodigo () {
      let listaCombustiveis = []
      for (let key in this.combustiveis_selecionados) {
        if (this.combustiveis_selecionados[key]) {
          listaCombustiveis.push(key)
        }
      }
      this.$store
        .dispatch('inserirCodigoPromocionalConvenio', {
          convenio: this.convenio,
          combustiveis: listaCombustiveis
        })
        .then(() => {
          this.dialogInsercao = false
          this.$refs.form.reset()
          this.carregarCodigos(this.convenio)
        })
    }
  }
}
</script>
